import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Library } from "./library.model";
import { ObjectDetailService } from "../../search/object-detail/object-detail.service";
import { BingMapService } from "../../bing-maps/service/bing-map.service";
import { AppConfigService } from "../../config/app-config.service";
import { HtmlUtilsService } from "../../html-utils/html-utils.service";
import { TranslateService } from "../../shared/translate.service";
import { Subscription } from "rxjs";
import { InsititutionsService } from "../insititutions.service";
import { isEmpty } from "lodash";

@Component({
  selector: "app-institutions-list",
  templateUrl: "./institutions-list.component.html",
  styleUrls: ["./institutions-list.component.scss"],
})
export class InstitutionsListComponent implements OnInit, OnDestroy, OnChanges {
  private mobile: boolean;

  private mobileSubscription: Subscription;

  @Output() libraryCount = new EventEmitter<number>();

  @Output() pageChange = new EventEmitter<number>();

  @Input() libraries: Library[] = [];

  @Input() shouldHideWrapper = false;

  @Input() shouldHideRefresh = false;

  @Input() shouldHideDigital = false;

  @Input() navigationOnRight = false;

  @Input() hideMaterializationCount = false;

  @Input() institutionsView = false;

  @Input() sortBy;

  @Input() filters;

  @ViewChild("librariesWrap") private librariesWrap: ElementRef;

  pageCount: number;

  onlyDigital = false;

  librariesNumbers: Map<string, number> = new Map();

  pageNumber = 1;

  pageSize: number;
  pageSizeOptions: number[];

  libsCount: number;

  onlineCount: number;

  showDistanceLabels = false;

  inProgress: boolean = true;

  constructor(
    private objectDetailService: ObjectDetailService,
    private mapsService: BingMapService,
    public config: AppConfigService,
    public htmlUtils: HtmlUtilsService,
    public translateService: TranslateService,
    private _institutionsService: InsititutionsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filters) {
      changes.filters = this.filters;
      if (!isEmpty(this.filters)) {
        this.pageNumber = 0;
        this.setPage(this.pageNumber);
        this.pageSize = this.pageSizeOptions[0];
        this.getAllLibs(0);
      }
    }
    if (this.libraries != null) {
      this.libraries
        .filter((l) => !l.online)
        .forEach((l) => {
          l.url = this.getLibraryUrl(l);
        });
    }
  }

  ngOnInit() {
    this.pageSizeOptions = [10, 20, 50, 100];
    // this.pageSize = this.institutionsView ? this.config.institutionsLibrariesPerPage : this.config.librariesPerPage;
    this.pageSize = 10;
    this.getAllLibs(0);
    this.mobile = this.htmlUtils.mobileVersion;
    this.mobileSubscription = this.htmlUtils.mobileBehaviorSubject.subscribe(
      (mobile) => (this.mobile = mobile)
    );
  }

  ngOnDestroy() {
    if (this.mobileSubscription) {
      this.mobileSubscription.unsubscribe();
    }
  }

  changePageSize(size: number) {
    this.pageSize = size;
    this.pageNumber = 0;
    this.setPage(this.pageNumber);
    this.getAllLibs(this.pageNumber);
  }

  getAllLibs(page: number): void {
    if (this.filters) {
      this._institutionsService
        .searchLibs(
          page,
          this.pageSize,
          this.filters.sort,
          this.filters.institutionName,
          this.filters.city,
          this.filters.region,
          this.filters.type
        )
        .subscribe((data) => {
          this.inProgress = false;
          this.libsCount = data.count;
          this.onlineCount = data.digital;
          this.libraries = data.libraries;
          this.pageCount = Math.ceil(data.count / this.pageSize);
        });
    } else {
      this._institutionsService
        .getLibs(page, this.pageSize)
        .subscribe((data) => {
          this.inProgress = false;
          this.libsCount = data.count;
          this.onlineCount = data.digital;
          this.libraries = data.libraries;
          this.pageCount = Math.ceil(data.count / this.pageSize);
        });
    }
  }

  public static isEqual(arr1: Library[], arr2: Library[]): boolean {
    return (
      arr1.sort((a, b) => +a.id - +b.id).toString() ===
      arr2.sort((a, b) => +a.id - +b.id).toString()
    );
  }

  onPageChange(page: string) {
    this.setPage(+page);
  }

  getLibraryUrl(library: Library): string {
    if (library && library.url) {
      return HtmlUtilsService.createUrl(library.url);
    }
  }

  getDigitalCount() {
    return this.onlineCount ? this.onlineCount : 0;
  }

  getNotDigitalCount() {
    return this.libsCount ? this.libsCount - this.onlineCount : 0;
  }

  hasNext() {
    return this.pageCount >= this.pageNumber + 1;
  }

  hasPrev() {
    return this.pageNumber - 1 >= 1;
  }

  goToNext() {
    this.pageNumber++;
    this.setPage(this.pageNumber);
  }

  goToPrev() {
    this.pageNumber--;
    this.setPage(this.pageNumber);
  }

  filterDigital(force?: boolean): Library[] {
    if (this.onlyDigital || force) {
      return this.libraries.filter((value) => value.online);
    } else {
      return this.libraries;
    }
  }

  private setPropeties(libs: Library[]) {
    this.libraryCount.emit(this.libraries.length);
  }

  private setPage(page): void {
    if (page > this.pageCount) {
      this.pageNumber = this.pageCount;
    } else if (page < 1) {
      this.pageNumber = 1;
      this.setPage(1);
    } else {
      this.setPropeties(
        this.libraries.slice((page - 1) * this.pageSize, page * this.pageSize)
      );
    }
    this.inProgress = true;
    this.getAllLibs(this.pageNumber - 1);
  }

  private updateNumbers(libraries: Library[]): void {
    this.librariesNumbers = new Map();
    let i = 1;
    for (const lib of libraries) {
      if (lib.online) {
        this.librariesNumbers.set(lib.name, -1);
      } else {
        this.librariesNumbers.set(lib.name, i++);
      }
    }
  }
}
